module.exports = __webpack_public_path__ + "img/GTM-integration-vidjet-step5.307069a8.png";